import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router'; 
import { Subscription } from 'rxjs';
import { CommonServices } from 'src/app/Common/CommonServices';
import { HostPortalClient, User, Webinar, WebinarClient, WebinarQueue, WebinarQueueDTO, WebinarRoomOwnerDTO } from 'src/app/Services/WOWApi.Service';
import { CommonService } from 'src/app/Services/common.service';
import { CustomServiceService } from 'src/app/Services/custom-service.service';
import { openConfirmDialog } from 'src/app/confirm-dialog/confirm-dialog.component';
import { formatTimeSlot, slotIcon as hostSlotIcon, slotToneFromLabel } from '../host-format';

@Component({
    selector: 'app-my-webinar-queue',
    templateUrl: './my-webinar-queue.component.html',
    styleUrls: ['./my-webinar-queue.component.css'],
    standalone: false
})
export class MyWebinarQueueComponent implements OnInit, OnDestroy {
  webiarQueues: WebinarQueueDTO[] = [];
  loggedUser: User;
  @Output() EditWebinar = new EventEmitter<number>();
  isMobileView = false;
  subscription: Subscription;
  minHeight: number = 0;
  webinarQueueDivDisplay = 'none';
  @Input() hostRoom: WebinarRoomOwnerDTO[];
  @Input() isOwnerPortal: boolean = false; // Flag to indicate if loaded from owner portal
  WebinarRoomControl = new FormControl();
  selectedRoomName = '';
  
  constructor(public hostPortalClient: HostPortalClient, private router: Router
    , private customServices:CustomServiceService, private commonService: CommonService,
    private dialog: MatDialog, private webinarClient: WebinarClient,
    private commonServices: CommonServices) { }

  ngOnInit(): void {
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
    this.loggedUser = this.customServices.GetLoggedInUser();
    
    // Add null check for hostRoom
    if (this.hostRoom && this.hostRoom.length > 0) {
      this.getData(this.hostRoom[0].webinarRoomId);
      this.WebinarRoomControl.setValue(this.hostRoom[0].webinarRoomId);
    }
  }

getData(webinarRoomId: number) {
  this.hostPortalClient.webinarQueues(webinarRoomId).subscribe(data => { 
    this.webiarQueues = data.sort((a, b) => a.timeSlotId - b.timeSlotId) || [];
    setTimeout(() => {
      let heightSet = 0;
      if (this.webiarQueues && this.webiarQueues.length > 0) {
        this.webiarQueues.map((queue, i) => {
          const ele = document.getElementById('webinarQueue_' + i);
          if (ele && ele.offsetHeight > heightSet) {
            heightSet = ele.offsetHeight;
          }
        });
      }
      this.minHeight = heightSet;
    }, 100); 
    this.webinarQueueDivDisplay = 'block';
    const room = this.hostRoom.find(x => x.webinarRoomId === webinarRoomId);
    this.selectedRoomName = room.roomName;
  }, error => {
    console.error('Error loading webinar queues:', error);
    this.webiarQueues = [];
  });
  }
  getWebinarData(e) {
    this.getData(e.value);
  }

  slotTone(queue: WebinarQueueDTO, index = 0) {
    return slotToneFromLabel(queue?.timeSlot, index);
  }

  slotIcon(queue: WebinarQueueDTO, index = 0): string {
    return hostSlotIcon(this.slotTone(queue, index));
  }

  queueCount(queue: WebinarQueueDTO): number {
    return queue?.webinarQueue?.length || 0;
  }

  postedCount(queue: WebinarQueueDTO): number {
    return (queue?.webinarQueue || []).filter(item => item.isPosted).length;
  }

  pendingCount(queue: WebinarQueueDTO): number {
    return this.queueCount(queue) - this.postedCount(queue);
  }

  soldSeats(row: WebinarQueue): number {
    return (row?.totalSeats || 0) - (row?.availableSeats || 0);
  }

  isFreeBee(row: WebinarQueue): boolean {
    return !!(row as WebinarQueue & { isFreeBee?: boolean }).isFreeBee;
  }

  hasCover(row: WebinarQueue): boolean {
    return !!row?.image && String(row.image).trim().length > 20;
  }

  coverStyle(row: WebinarQueue): { [key: string]: string } {
    return { 'background-image': `url(data:image/jpg;base64,${row.image})` };
  }

  formatTimeSlot(slot?: string): string {
    return formatTimeSlot(slot);
  }

  formatVideoLength(value?: string | number): string {
    const seconds = Number(value);
    if (!Number.isFinite(seconds) || seconds < 0) {
      return '0:00';
    }
    const minutes = Math.floor(seconds / 60);
    const remainder = Math.round(seconds % 60);
    return `${minutes}:${String(remainder).padStart(2, '0')}`;
  }

  
  editWebinar(row: any) { 
    this.EditWebinar.emit(row.webinarId);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  roomDescription(desc: string) {
    if (desc.split(' ')[2] === undefined && desc.length > 40) {
      const lengthDesc = desc.length;
      const partSize = Math.floor(lengthDesc/10);
      let description = '';
      for (let i = 0; i < 10; i++) {
        description += ' ' + desc.slice(partSize * i, partSize * (i+1));
      }
     return description;
    } else {
      return desc;
    }
  }

  onDeleteWebinar(webinar: WebinarQueue) {
    console.log(webinar)
    openConfirmDialog(this.dialog, {
        message: `Are you sure, you want to delete the webinar '${webinar.webinarName}' ?`,
        buttonText: {
          ok: 'Yes, Delete',
          cancel: 'No, Cancel'
        }
    }).afterClosed().subscribe(res => {
      if (res === true) {
        this.webinarClient.deleteUnsusedWebinar(webinar.webinarId).subscribe(res => {
          if (res === true) {
            if (this.webiarQueues && this.webiarQueues.length > 0) {
              const list = JSON.parse(JSON.stringify(this.webiarQueues));
              // Find and remove the webinar from all queues
              list.forEach(queue => {
                if (queue.webinarQueue) {
                  const idx = queue.webinarQueue.findIndex(x => x.webinarId === webinar.webinarId);
                  if (idx > -1) {
                    queue.webinarQueue.splice(idx, 1);
                  }
                }
              });
              this.webiarQueues = list;
            }
            this.commonServices.showMessage('success', 'Webinar deleted successfully.');
          } else {
            this.commonServices.showMessage('error', 'Could not delete the webinar, This might have reviews on the webinar or seat might have sold.', 10);
          }
        }, error => {
          this.commonServices.showMessage('error', error, 10);
        });
      }
    })
  }
}
